<section class="touch-slider-wrp mt-5 new-arrival-wrp new-arrive-inner-slider"
         *ngIf="responseReceived && products.length > 0">
  <div class="container">
    <div class="touch-slider-wrp-inner">
      <h4 class="heading-w-border mb-2">
        <span>Just Arrived In Town</span>
      </h4>

      <div class="touch-slider">

        <div uk-slider>
          <div class="uk-position-relative">

            <div class="uk-slider-container uk-light mt-4">
              <ul
                class="uk-slider-items uk-child-width-1-1 uk-child-width-1-2@s uk-child-width-1-2@m uk-grid-small uk-flex-middle uk-grid"
                uk-grid>


                <li *ngFor="let product of products">
                  <app-standard-product-card [data]="product"></app-standard-product-card>
                </li>

              </ul>
            </div>
            <!--uk-slider-container--->

            <a class="uk-position-center-left-out custom-nav hideMobile" href="#" uk-slidenav-previous
               uk-slider-item="previous">
              <img src="assets/images/icons/arrow-right.png" alt="">
            </a>
            <a class="uk-position-center-right-out custom-nav hideMobile" href="#" uk-slidenav-next
               uk-slider-item="next">
              <img src="assets/images/icons/arrow-right.png" alt="">
            </a>

          </div>
        </div>

      </div>
      <!--touch-slider-wrp-inner--->
    </div>
  </div>
  <!--container--->
</section>

<!--Skeleton Loader-->
<section class="touch-slider-wrp mt-5 new-arrival-wrp new-arrive-inner-slider" hidden>
  <div class="container">
    <div class="touch-slider-wrp-inner">

      <div class="touch-slider">

        <div uk-slider *ngIf="!responseReceived">
          <div class="uk-position-relative">

            <div class="uk-slider-container uk-light mt-4">
              <ul
                class="uk-slider-items uk-child-width-1-1 uk-child-width-1-2@s uk-child-width-1-2@m uk-grid-small uk-flex-middle uk-grid"
                uk-grid>


                <li *ngFor="let product of products">
                  <div class="popular-experiences-wrp-inner uk-flex uk-flex-wrap">
                    <div class="popular-experiences-card bg-gray mb-4 w-46 uk-flex">
                      <ngx-skeleton-loader animation="progress" appearance="line"></ngx-skeleton-loader>
                    </div>
                  </div>
                </li>

              </ul>
            </div>
            <!--uk-slider-container--->
          </div>
        </div>
      </div>
      <!--touch-slider-wrp-inner--->
    </div>
  </div>
  <!--container--->
</section>
